import { useState, useEffect } from "react";
import { getCurrentDate } from "../../../configs/helpers";
import { AccountReceiveSearch } from "../fragments.accounting/AccountReceiveSearch";
import {
    fetchedAllOperationsAccountReceiveByClient,
    fetchedDebtors,
    fetchedAllSellers,
} from "../../../apis/apis.accounting/apisCash";
import { AccountReceiveOperations } from "../fragments.accounting/AccountReceiveOperations";
import { AccountReceiveList } from "../fragments.accounting/AccountReceiveList";

const initialCashFlowState = {
    transactionDate: getCurrentDate("-"),
    description: "",
    type: "E",
    operationID: 0,
    total: 0,
    userID: 0,
    originalPending: 0,
};

export function AccountReceivePage() {
    const [sales, setSales] = useState([]);
    const [cashFlow, setCashFlow] = useState(initialCashFlowState);
    const [cashFlowSet, setCashFlowSet] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dates, setDates] = useState({
        startDate: getCurrentDate("-"),
        endDate: getCurrentDate("-"),
    });
    const [debtors, setDebtors] = useState([]);
    const [sellers, setSellers] = useState([]);
    const [debtorItem, setDebtorItem] = useState({
        debtorCashID: "0",
        debtorCashAmount: "0",
        debtorCashName: "",
        debtorCashStatus: "",
        debtorClientID: "0",
        debtorClientName: "",
        debtorClientVisitDay: "0",
        debtorClientObservation: "",
        debtorClientGangName: "",
    });

    const getAllSellers = async () => {
        try {
            const response = await fetchedAllSellers();
            setSellers(response.filter((s) => s.isActive));
        } catch (error) {
            throw error;
        }
    };

    useEffect(() => {
        getAllSellers();
    }, []);

    const getClientsWithDebt = async () => {
        try {
            const response = await fetchedDebtors();
            const uniqueDebtors = new Map();
            response.forEach((mobile) => {
                if (!uniqueDebtors.has(mobile["clientID"])) {
                    uniqueDebtors.set(mobile["clientID"], {
                        value: mobile["clientID"],
                        label: mobile["clientName"],
                        clientName: mobile["clientName"],
                        clientVisitDay: mobile["clientVisitDay"],
                        clientObservation: mobile["clientObservation"],
                        clientGangName: mobile["clientGangName"],
                        totalPending: mobile["totalPending"],
                    });
                }
            });
            setDebtors(Array.from(uniqueDebtors.values()));
        } catch (error) {
            throw error;
        }
    };

    const getAllAccountReceiveList = async () => {
        try {
            const response = await fetchedAllOperationsAccountReceiveByClient({
                clientID: debtorItem.debtorClientID,
                startDate: dates.startDate,
                endDate: dates.endDate,
            });
            setSales(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Cuentas por cobrar
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">
                                    Finanzas
                                </li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">
                                    /
                                </li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">
                                    Cuentas por cobrar
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            {/* Main content */}
            <section>
                <div className="max-w-full px-4 space-y-4">
                    {/* Search panel */}
                    <AccountReceiveSearch
                        setDebtorItem={setDebtorItem}
                        debtorItem={debtorItem}
                        dates={dates}
                        setDates={setDates}
                        getAllAccountReceiveList={getAllAccountReceiveList}
                        getClientsWithDebt={getClientsWithDebt}
                        debtors={debtors}
                    />

                    {/* Client info banner */}
                    {debtorItem.debtorClientName.length > 0 && (
                        <div className="flex items-center gap-4 rounded-xl border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 px-5 py-4">
                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 dark:bg-blue-800 flex items-center justify-center">
                                <i className="fas fa-user text-blue-600 dark:text-blue-300"></i>
                            </div>
                            <div className="min-w-0">
                                <p className="text-xs text-blue-500 dark:text-blue-400 font-medium uppercase tracking-wide mb-0.5">
                                    Estado de cuenta
                                </p>
                                <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                                    {debtorItem.debtorClientName}
                                </p>
                                <div className="flex flex-wrap gap-4 mt-1 text-xs text-gray-500 dark:text-gray-400">
                                    <span>
                                        <span className="font-medium text-gray-700 dark:text-gray-300">
                                            Código:
                                        </span>{" "}
                                        {debtorItem.debtorClientObservation}
                                    </span>
                                    <span>
                                        <span className="font-medium text-gray-700 dark:text-gray-300">
                                            Ruta:
                                        </span>{" "}
                                        {debtorItem.debtorClientGangName}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* List */}
                    <AccountReceiveList
                        sales={sales}
                        setCashFlow={setCashFlow}
                        setCashFlowSet={setCashFlowSet}
                        setIsModalOpen={setIsModalOpen}
                    />

                    {/* Operations modal */}
                    <AccountReceiveOperations
                        setCashFlow={setCashFlow}
                        cashFlow={cashFlow}
                        cashFlowSet={cashFlowSet}
                        setCashFlowSet={setCashFlowSet}
                        getAllAccountReceiveList={getAllAccountReceiveList}
                        getClientsWithDebt={getClientsWithDebt}
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                        sellers={sellers}
                    />
                </div>
            </section>
        </>
    );
}
